export default __webpack_public_path__ + "static/1-cdcd15a26af688d1e2742ca80c684c2b.png";